






















































import {
    defineComponent,
    ref,
    computed
} from "@vue/composition-api";
import { alarm, app } from "@/store";
import useIOSDetection from "@/utilities/useIOSDetection";

export default defineComponent({
    name: "GeoPermission",
    props: {
        destination: { type: String, required: true },
    },
    setup(_, { root }) {

        const isIOS = useIOSDetection().isIos();

        const destination = root.$route.params.destination;

        const errorMessage = ref<string>("");

        const showError = computed<boolean>(() => {
            return errorMessage.value != "";
        });

        const permissionText = computed<string>(() => {
            return "We need your permission to access your location. Please click on the button bellow and when prompted, select \"Allow while using the app\"";
        });

        const instructionHeader = computed<string>(() => {
            if (isIOS) {
                return "iOS Instructions (Safari)";
            } else {
                return "Android Instructions";
            }
        });

        const instructionText = computed<string>(() => {
            if (isIOS) {
                return "When prompted, click \"Allow\"";
            } else {
                return "When prompted, select \"Precise\" and then \"While using the app\"";
            }
        });

        const requestUserPosition = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position: GeolocationPosition) => {
                        handlePositionSuccess(position);
                    },
                    (error: GeolocationPositionError) => {
                        handlePositionError(error);
                    },
                    { enableHighAccuracy: true, timeout: 20000, maximumAge: 0 }
                );
            } else {
                errorMessage.value = "Geolocation is not supported by this browser.";
                app.error = errorMessage.value;
            }
        };

        const handlePositionSuccess = (position: GeolocationPosition) => {
            alarm.setUserLocation(position);
            if (destination == "mob" && alarm.userLocReady) {
                root.$router.push({ name: "mob" });
            } else if (destination == "map" && alarm.userLocReady) {
                root.$router.push({ name: "map" });
            } else {
                root.$router.push({ name: "home" });
            }
        };

        const handlePositionError = (error: GeolocationPositionError) => {
            if (error.code === error.PERMISSION_DENIED) {
                errorMessage.value = "User denied the request for geolocation.";
            } else if (error.code === error.POSITION_UNAVAILABLE) {
                errorMessage.value = "Location information is unavailable.";
            } else if (error.code === error.TIMEOUT) {
                errorMessage.value = "The request to get user location timed out.";
            } else {
                errorMessage.value = "An unknown error occurred.";
            }
            app.error = errorMessage.value;
        };

        return {
            requestUserPosition,
            errorMessage,
            instructionHeader,
            instructionText,
            permissionText,
            showError,
            isIOS,
        };
    },
});
